export const SCALINATA_LATEST_RULES_VERSION = 1;
export const SCALINATA_VARIANTS = {
  0: { wordLengths: [4, 5, 6, 7, 8], maxGuesses: 20 },
  1: { wordLengths: [5, 6, 7, 8], maxGuesses: 16 },
};

export const SPETTRI_LATEST_RULES_VERSION = 1;
export const SPETTRI_VARIANTS = {
  0: { itemsPerSpectrum: 5 },
  1: { itemsPerSpectrum: 4 },
};

export const getScalinataRulesVersion = (config = null) => {
  const explicit = config?.rules_version;
  if (Number.isInteger(explicit) && SCALINATA_VARIANTS[explicit]) {
    return explicit;
  }

  const rawWords = Array.isArray(config?.secret_words)
    ? config.secret_words
    : Array.isArray(config?.words)
      ? config.words
      : [];
  if (rawWords.length === 5) return 0;

  const wordLengths = Array.isArray(config?.word_lengths) ? config.word_lengths : [];
  if (wordLengths.length === 5) return 0;

  const answers = Array.isArray(config?.answers) ? config.answers : [];
  if (answers.length === 5) return 0;

  const guessLevels = config?.guesses && typeof config.guesses === 'object'
    ? Object.keys(config.guesses).map(Number).filter(Number.isInteger)
    : [];
  if (guessLevels.some((level) => level >= 4)) return 0;

  return SCALINATA_LATEST_RULES_VERSION;
};

export const getScalinataWordLengths = (config = null) => {
  if (Array.isArray(config?.word_lengths) && config.word_lengths.length > 0) {
    return config.word_lengths;
  }
  const rulesVersion = typeof config === 'number' ? config : getScalinataRulesVersion(config);
  return SCALINATA_VARIANTS[rulesVersion]?.wordLengths || SCALINATA_VARIANTS[SCALINATA_LATEST_RULES_VERSION].wordLengths;
};

export const getScalinataMaxGuesses = (config = null) => {
  const rulesVersion = typeof config === 'number' ? config : getScalinataRulesVersion(config);
  return SCALINATA_VARIANTS[rulesVersion]?.maxGuesses || SCALINATA_VARIANTS[SCALINATA_LATEST_RULES_VERSION].maxGuesses;
};

export const getScalinataNumLevels = (config = null) => getScalinataWordLengths(config).length;

export const getSpettriRulesVersion = (config = null) => {
  const explicit = config?.rules_version;
  if (Number.isInteger(explicit) && SPETTRI_VARIANTS[explicit]) {
    return explicit;
  }

  const spectra = Array.isArray(config?.spectra) ? config.spectra : [];
  const firstSpectrumItems = Array.isArray(spectra[0]?.items) ? spectra[0].items : [];
  if (firstSpectrumItems.length === 5) return 0;
  return SPETTRI_LATEST_RULES_VERSION;
};

export const getSpettriItemsPerSpectrum = (config = null) => {
  if (Number.isInteger(config?.items_per_spectrum) && config.items_per_spectrum > 0) {
    return config.items_per_spectrum;
  }
  const rulesVersion = typeof config === 'number' ? config : getSpettriRulesVersion(config);
  return SPETTRI_VARIANTS[rulesVersion]?.itemsPerSpectrum || SPETTRI_VARIANTS[SPETTRI_LATEST_RULES_VERSION].itemsPerSpectrum;
};

export const getSpettriAllowedFixedPositions = (itemsPerSpectrum) => {
  const center = itemsPerSpectrum % 2 === 1 ? Math.floor(itemsPerSpectrum / 2) : null;
  return Array.from({ length: itemsPerSpectrum }, (_, idx) => idx).filter((idx) => idx !== center);
};
